function initLandingStandalone() {
    if (!document.body.classList.contains('single-landing-standalone')) {
        return;
    }

    // gsap.to("body", 10, {
    //     opacity: 0
    // });

    const items = document.querySelectorAll('[data-aos]');
    items.forEach((item) => {
        ScrollTrigger.create({
            trigger: item,
            start: 'top 90%',
            once: true,
            toggleClass: "appeared"
        });
    });


}